import React, {useEffect, useState} from 'react';
import {Flex} from "@chakra-ui/layout";
import socket from "../../../utilities/socket";
import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  useDisclosure
} from "@chakra-ui/react";
import Plus from "../../../images/teacher/plus.svg";
import {useHistory, useRouteMatch} from "react-router-dom";
import {useSelector} from "react-redux";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {getTeacherOwnedCourses} from "../../../action/teacherAction";

function TeacherClasses() {
  const dispatch = useStudentAuthDispatch();
  const {data, courses: {courses}} = useSelector((state: StateType) => state.rootReducer.teacherReducer);
  console.log(courses);
  const teacherToken = data.token.includes("Bearer") ? data.token.slice(17, (data.token.length - 2)) : data.token.slice(10, (data.token.length - 2));

  const {isOpen, onOpen, onClose} = useDisclosure();
  const history = useHistory();
  const [startClass, setStartClass] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  function handleClass(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    console.log(startClass);
    if (startClass === "") {
      return setErrorMessage("Please select a class");
    }
    setErrorMessage("")
    history.push(`/class/${startClass}`);
  }

  useEffect(() => {
    dispatch(getTeacherOwnedCourses(teacherToken))
    socket.connect();
    socket.on("joined", (id) => {
      console.log(id)
    })
  }, []);

  return (
    <Flex justifyContent={"center"} mt={10}>
      <Button onClick={onOpen} bgColor={"white"} fontSize={"sm"} fontWeight={"semibold"} borderRadius={"2xl"}
              size={"lg"}>
        <Image
          boxSize="30px"
          objectFit="cover"
          mr={"12px"}
          src={Plus}
          alt="profile icon"
        />
        Start Class
      </Button>

      <Modal closeOnOverlayClick={true} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay/>
        <ModalContent>
          <ModalHeader>Start A Class</ModalHeader>
          <ModalCloseButton/>
          <ModalBody pb={6}>
            <FormControl isInvalid={errorMessage !== ""}>
              <FormLabel>Class</FormLabel>
              <Select required value={startClass} onChange={(e) => setStartClass(e.target.value)}
                      placeholder="Choose course to start class for">
                {courses.map((course: any, index) => (
                  <option key={index} value={course.course_name}>{course.course_name}</option>
                ))}
              </Select>
              <FormErrorMessage>{errorMessage}</FormErrorMessage>
            </FormControl>

          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={(e) => handleClass(e)}>
              Start A Class
            </Button>
            <Button onClick={onClose}>Cancel</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Flex>
  );
}

export default TeacherClasses;